const styles = theme => ({
  root: {
    height: '100%',
    width: '100%',
    '.dialog-title': {
      display: 'flex',
      'flex-direction': 'row',
      '-ms-flex-direction': 'row',
    },
    flex: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  // button: { bottom: 0, position: 'absolute' },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/review/termsAndConditions/TermsDialogStyles.js